import { Box, Grid2 as Grid } from "@mui/material";
import { useAtom } from "jotai";
import { OrganizationProfile } from "../../profile";
import { Button } from "../../common";
import {
  createOrganizationWizardStepAtom,
  isCreateOrganizationModeAtom,
  selectedOrgIdAtom,
} from "../../../atoms";
import { useFetchOrganizationInfoQuery } from "../../../api";
import { useNavigate } from "react-router-dom";
import { SadmOrganizationsRoute } from "../../../routes";

export const OrganizationDetailsStep = () => {
  const [, setStep] = useAtom(createOrganizationWizardStepAtom);
  const [selectedOrgId] = useAtom(selectedOrgIdAtom);
  const [, setIsCreateOrganizationMode] = useAtom(isCreateOrganizationModeAtom);
  const navigate = useNavigate();

  const isOrganizationCreated = !!selectedOrgId && selectedOrgId !== 0;

  const fetchOrganizationInfoQuery = useFetchOrganizationInfoQuery(
    selectedOrgId || 0,
    { enabled: isOrganizationCreated },
  );

  const isStepComplete =
    isOrganizationCreated &&
    !!fetchOrganizationInfoQuery.data?.contactPerson &&
    !!fetchOrganizationInfoQuery.data?.mobileNumber;

  const handleCancel = () => {
    setIsCreateOrganizationMode(false);
    navigate(SadmOrganizationsRoute.path);
  };

  return (
    <Grid
      container
      direction="column"
      sx={{
        width: "100%",
      }}
    >
      <Grid size={12}>
        <OrganizationProfile />
      </Grid>

      <Grid
        size={12}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          gap: 2,
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 2, sm: 3 },
        }}
      >
        <Button
          label="Cancel"
          variantType="secondary"
          sx={{
            padding: "0.5rem",
            px: "1.5rem",
            width: { xs: "100%", sm: "auto" },
          }}
          onClick={handleCancel}
        />
        <Button
          label="Next: Wash Types"
          variantType={isStepComplete ? "primary" : "secondary"}
          disabled={!isStepComplete}
          sx={{ padding: "0.5rem", px: "1.5rem" }}
          onClick={() => setStep(1)}
        />
      </Grid>
    </Grid>
  );
};
